import CameraIcon from '@atlaskit/icon/core/camera';
import * as React from 'react';

export function SvgCamera() {
  return <CameraIcon label="" testId="ads-refreshed-icon" />;
}
